<template lang="pug">
  v-data-table.elevation-1(:headers='headers' :items='exams' )
    template(v-slot:top)
      v-toolbar(flat='' color='white')
        v-toolbar-title Examenes
        v-divider.mx-4(inset='' vertical='')
        .flex-grow-1
        v-dialog(v-model='dialog' max-width='500px' fullscreen='' hide-overlay='' transition='dialog-bottom-transition' scrollable='')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark='' v-on='on') Nuevo Examen
          v-card(tile='')
            v-toolbar(flat='' dark='' color='primary' style='flex:initial;')
              v-btn(icon='' dark='' @click='dialog = false')
                v-icon mdi-close
              v-toolbar-title {{ formTitle }}
              .flex-grow-1
              v-toolbar-items
                v-btn(dark='' text='' @click='save')
                  | Save
            v-card-text
              v-container
                v-row
                  input(type='hidden' v-model='editedItem.id')
                  v-col
                    v-text-field(v-model='editedItem.name' label='Nombre' required= '' :rules='nameRules')
                  v-col
                    v-text-field(v-model='editedItem.time' label='Duración del Examen (Minutos)' type='number' required= '' :rules='nameRules')
                  v-col
                    v-text-field(v-model='editedItem.desc' label='Descripción')
                  v-col
                    v-switch(label="Modo manual" v-model='manual' :disabled='block_edit')
                  v-col
                    .counter-questions Preguntas asignadas: {{ counterQuestions }}
                v-row
                  v-col
                v-row
                  template(v-if='manual')
                    v-col
                      v-select(:items='levels' ref='lvlSelect' item-text='name' item-value='id' v-model='lvl_id' label='Nivel' @change='getQuestionsByLvl()' required)
                    v-col
                      v-row
                        v-col
                          v-data-table.elevation-1(v-model='selectedQuestions' :headers='questionHeaders' :items='questions' :single-select='singleSelect' item-key='id' show-select='')
                      v-row
                        v-col
                          v-btn.save-lvl(color='blue' @click='saveLvl') Guardar preguntas por nivel
                  template(v-else)
                    v-col
                      v-select(:items='levels' ref='lvlSelect' item-text='name' item-value='id' v-model='lvl_id' label='Nivel')
                    v-col
                      v-text-field(v-model='autoNoQ' label='Preguntas por nivel')
                    v-col
                      v-btn.save-lvl(color='blue' @click='saveLvl') Agregar preguntas

                  v-col
                    template(v-if='manual')
                      v-combobox(v-model='selectQuestionOpts' :items='itemsQuestionsOpts' item-text='level' item-value='level' label='Estado actual por nivel' multiple='' chips='')
                        template(v-slot:selection='data')
                          v-chip(:key='JSON.stringify(data.item)' v-bind='data.attrs' :input-value='data.selected' :disabled='data.disabled' @click:close='data.parent.selectItem(data.item)')
                            v-avatar.accent.white--text(left='' v-text='data.item.questions.length')
                            | {{ data.item.level }}
                    template(v-else)
                      v-combobox(v-model='autoSelectQuestionsOpts' :items='autoQuestionsOpts' item-text='level' item-value='level' label='Estado actual por nivel' multiple='' chips='')
                        template(v-slot:selection='data')
                          v-chip(:key='JSON.stringify(data.item)' v-bind='data.attrs' :input-value='data.selected' :disabled='data.disabled' @click:close='data.parent.selectItem(data.item)')
                            v-avatar.accent.white--text(left='' v-text='data.item.numberQ')
                            | {{ data.item.level }}

    template(v-slot:item.url='{ item }')
      a(:href='`https://cepi-eng.web.app/#/user/lanTest?id=${item.id}`') https://cepi-eng.web.app/#/user/lanTest?id={{item.id}}
    template(v-slot:item.action='{ item }')
      v-icon.mr-2(small='' @click='editItem(item)')
        | edit

    template(v-slot:no-data='')
      v-btn(color='primary' @click='initialize') Reset

</template>

<script>

  import { config } from '../config.js'

  export default {
    data: () => ({
      nameRules: [
          v => !!v || 'El campo de nombre es obligatorio'
      ],
      dialog: false,
      manual: false,
      block_edit: false,
      lvl_id: '',
      autoNoQ: 0,
      loading: false,
      singleSelect: false,
      selectedQuestions: [],
      counterQuestions: 0,
      levels: [],
      selectQuestionOpts: [

      ],
      itemsQuestionsOpts: [

      ],
      autoQuestionsOpts: [],
      autoSelectQuestionsOpts: [],
      questionHeaders: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Nombre', value: 'name', sortable: false },
        { text: 'Nivel', value: 'lvl', sortable: true },
        { text: 'Categoría', value: 'cat', sortable: true },
        { text: 'Subcategoría', value: 'subcat', sortable: true },
        { text: 'Tipo de Respuesta', value: 'ans_type_desc', sortable: false }
      ],
      headers: [
        {
          text: 'Nombre del Examen',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Descripción', value: 'desc', sortable: false },
        { text: 'Url del Examen', value: 'url', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      exams: [],
      categories: [],
      questions: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        desc: '',
        time:'',
        updateDate: '',
        questions: []
      },
      defaultItem: {
        id:'',
        name: '',
        desc: '',
        time:'',
        updateDate: '',
        questions: []
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo examen' : 'Editar examen'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      selectQuestionOpts() {
        this.updateQuestionCounter();
      },
    },

    created () {
      this.initialize();
      this.updateQuestionCounter();
    },

    methods: {
      initialize () {

        this.axios.get(`${config.serviceUri}exams`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.exams = response.data.payload;
            this.loading = false;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.loading = false;
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=levels`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.levels = response.data.payload.sort(function (a, b) {
                            if (a.name > b.name) {
                              return 1;
                            }
                            if (a.name < b.name) {
                              return -1;
                            }
                            return 0;
                          });

            this.loading = false;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.loading = false;
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=subcategories`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.subcategories = response.data.payload;
            this.loading = false;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.loading = false;
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=categories`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.categories = response.data.payload;
            this.loading = false;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.loading = false;
        });
      },

      editItem (item) {
        this.editedIndex = this.exams.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.block_edit = true;

        if(this.editedItem.auto){
          this.manual = false;
          this.autoQuestionsOpts = this.autoQuestionsOpts.concat(this.editedItem.autoQuestions);
          this.autoSelectQuestionsOpts = this.autoSelectQuestionsOpts.concat(this.editedItem.autoQuestions);
          this.updateQuestionCounter();

        }else{
          this.itemsQuestionsOpts = this.itemsQuestionsOpts.concat(this.editedItem.questions);
          this.selectQuestionOpts = this.selectQuestionOpts.concat(this.editedItem.questions);
          this.manual = true;
          this.updateQuestionCounter();
        }

        this.dialog = true
      },

      deleteItem (item) {
        const index = this.categories.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.categories.splice(index, 1)
      },


      getQuestionsByLvl (){
        if(this.lvl_id){
          this.axios.get(`${config.serviceUri}questions?lvl=${this.lvl_id}`)
          .then( (response) => {
              console.log('Succes request: ',response.data);
              this.questions = response.data.payload;
              // this.loading = false;
          })
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.manual = false;
          this.lvl_id = '';
          this.autoNoQ = 0;
          this.selectQuestionOpts = [];
          this.itemsQuestionsOpts = [];
          this.autoQuestionsOpts = [];
          this.autoSelectQuestionsOpts = [];
          this.editedIndex = -1
        }, 300)
      },
      saveLvl(){

        let _level = this.$refs.lvlSelect.selectedItems[0].name;
        
        if(this.manual){

          if(this.itemsQuestionsOpts.filter( i => i.level == _level).length > 0){

            let indexModify;

            this.itemsQuestionsOpts.map( (q,i) => {
              if(q.level == _level){
                indexModify = i;
              }
            })

            this.itemsQuestionsOpts[indexModify].questions = this.itemsQuestionsOpts[indexModify].questions.concat(this.selectedQuestions);
            // this.selectQuestionOpts[indexModify].questions = this.selectQuestionOpts[indexModify].questions.concat(this.selectedQuestions);
          }else {

            let levelQuest = {};
            levelQuest.level = this.$refs.lvlSelect.selectedItems[0].name;
            levelQuest.questions = this.selectedQuestions;

            this.itemsQuestionsOpts.push(levelQuest);
            this.selectQuestionOpts.push(levelQuest);

          }
        }else{

          if(this.autoQuestionsOpts.filter( i => i.level == _level).length > 0){

            let indexModify;

            this.autoQuestionsOpts.map( (q,i) => {
              if(q.level == _level){
                indexModify = i;
              }
            })

            this.autoQuestionsOpts[indexModify].numberQ += Number(this.autoNoQ);

          }else {
            let levelQuest = {};
            levelQuest.level = this.$refs.lvlSelect.selectedItems[0].name;
            levelQuest.lvl_id = this.lvl_id;
            levelQuest.numberQ = Number(this.autoNoQ);
            
            this.autoQuestionsOpts.push(levelQuest);
            this.autoSelectQuestionsOpts.push(levelQuest);
          }
        }

        this.selectedQuestions = [];
        this.updateQuestionCounter();
      },
      updateQuestionCounter(){
        var auxOpts = [];
        var counter = 0;
        
        if(this.manual){
          auxOpts = [...this.selectQuestionOpts];
          
          auxOpts.map((q,i) => {
            counter += q.questions.length;
          });
        } else {
          auxOpts = [...this.autoQuestionsOpts];
          
          auxOpts.map((q,i) => {
            counter += Number(q.numberQ);
          });
        }
        
        this.counterQuestions = counter;
      },

      save () {
        
        if( !this.editedItem.name || ! this.editedItem.questions || ! this.lvl_id){
          console.error('El campo de nombre, preguntas y nivel es requerido!');
          this.dialog = false;
          return;
        }
        if (this.editedIndex > -1) {
          // Object.assign(this.categories[this.categories], this.editedItem)
        } else {
          console.log('New item');

          let newExam = Object.assign({},this.editedItem)
          
          if(this.manual){
            newExam.auto = false;
            newExam.questions = this.selectQuestionOpts;


            this.axios.post(`${config.serviceUri}exams`, newExam )
              .then( (response) => {
                  console.log('Succes Exam Created: ',response.data);
                  this.exams.push(response.data)
                  this.loading = false;
              })
              .catch( (error) => {
                  console.log('Error: ', error);
                  this.loading = false;
              });
          }else{
            newExam.auto = true;
            newExam.autoQuestions = this.autoSelectQuestionsOpts;

            this.axios.post(`${config.serviceUri}exams`, newExam )
              .then( (response) => {
                  console.log('Succes Exam Auto Created: ',response.data);
                  this.exams.push(response.data)
                  this.loading = false;
              })
              .catch( (error) => {
                  console.log('Error: ', error);
                  this.loading = false;
              });
          }

          
        }
        this.close()
      },
    },
  }
</script>


<style scoped>
.counter-questions {
  width: 100%;
  padding: 1rem;
  font-size: 2em;
  text-align: center;
}

.save-lvl{
  color: aliceblue;
  text-align: center;
  width: 50%;
  margin: auto 25%;
}
</style>
